// extracted by mini-css-extract-plugin
module.exports = {"template":"Main_template__wVGJ5","template_section":"Main_template_section__iLmJZ","template_background":"Main_template_background__UveoA"};